import React from 'react';
import { IconButton, makeStyles, Paper, Snackbar, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#FBEEC6', // Background color
    color: 'black', // Text color
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
  },
  closeButton: {
    color: 'black',
  },
  link: {
    color: 'black',
    textDecoration: 'underline',
    marginLeft: theme.spacing(1),
  },
}));

const CustomAlert = ({
  showPopup = false,
  setAlertControl = (value) => {},
  text = '',
  anchorText = '',
  anchorLink = '',
  style = {},
}) => {
  const classes = useStyles();
  return (
    <Snackbar
      open={showPopup}
      onClose={() => setAlertControl(false)}
      autoHideDuration={10000} // set null to Prevent auto-hide
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      ContentProps={{
        style: { marginTop: '30px' }, // Adjust this value as needed
      }}
      style={{ ...style }}
    >
      <Paper className={classes.root}>
        <Typography variant="body1" style={{ fontSize: '14px' }}>
          {text}
          {anchorText ? (
            <>
              {' '}
              OR
              <a href={anchorLink} target="_blank" rel="noopener noreferrer" className={classes.link}>
                <b>{anchorText}</b>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="16"
                  viewBox="0 0 21 20"
                  fill="none"
                  style={{ marginBottom: '-3px' }}
                >
                  <path
                    d="M16.3333 15.8333H4.66667V4.16667H10.5V2.5H4.66667C4.22464 2.5 3.80072 2.67559 3.48816 2.98816C3.17559 3.30072 3 3.72464 3 4.16667V15.8333C3 16.2754 3.17559 16.6993 3.48816 17.0118C3.80072 17.3244 4.22464 17.5 4.66667 17.5H16.3333C17.25 17.5 18 16.75 18 15.8333V10H16.3333V15.8333ZM12.1667 2.5V4.16667H15.1583L6.96667 12.3583L8.14167 13.5333L16.3333 5.34167V8.33333H18V2.5H12.1667Z"
                    fill="black"
                  />
                </svg>
              </a>
            </>
          ) : null}
        </Typography>
      </Paper>
    </Snackbar>
  );
};

export default CustomAlert;
